import clsx from 'clsx';
import {Link} from '@shopify/hydrogen';
import CartToggle from '../cart/CartToggle.client';
import {useEffect, useState} from 'react';
import {useSiteContext} from '../../hooks/useSiteContext';
import Flag from '../icons/Flag';
import {useAtom} from 'jotai';
import {countrySelectModalAtom} from '../../jotai';
import useGeo from '../../hooks/useGeo';

export default function UserButtons({flip}: any) {
  const {state} = useSiteContext();
  const [, setActive] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [, setShowCountrySelect] = useAtom(countrySelectModalAtom);
  const [countryFlag, setCountryFlag] = useState('NZ');

  const {preferredCountryCookie, currentCountryPath} = useGeo();

  useEffect(() => {
    setIsMobile(window.innerWidth < 1024);
    setCountryFlag(currentCountryPath);
  }, [preferredCountryCookie, currentCountryPath]);

  return (
    <div
      className={clsx([
        'transition-standard relative z-20 flex flex-row items-center justify-center gap-x-4',
        flip ? 'text-dark-gray' : 'text-white',
      ])}
    >
      {/* CART */}
      <div
        onMouseEnter={() => !state.shipping && setActive(true)}
        className={clsx([
          'relative mt-3 lg:h-full lg:py-4',
          !state?.shipping && 'opacity-50',
          isMobile && !state?.shipping && 'pointer-events-none',
        ])}
        data-testid="cart-icon-button"
      >
        <CartToggle />
      </div>

      {/* ACCOUNT */}
      <div>
        <Link aria-label="Login to account" to="/account">
          <svg
            className="flip transition-standard h-full w-5"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 17.2 21.8"
            xmlSpace="preserve"
          >
            <path
              fill="white"
              d="M15.6,12.7c-1-1.3-2.3-2.3-3.8-2.9C13,9,13.8,7.7,14,6.2c0.2-1.6-0.2-3.1-1.3-4.3C11.7,0.7,10.2,0,8.6,0
                            C7,0,5.5,0.7,4.5,1.9C3.4,3.1,3,4.6,3.2,6.2c0.2,1.5,1,2.8,2.2,3.6c-1.5,0.6-2.8,1.5-3.7,2.8l0,0.1c0,0,0,0,0,0l0,0.1
                            c-1,1.4-1.5,3-1.5,4.7v4.3h17.2v-4.3C17.2,15.8,16.7,14.1,15.6,12.7z M4.7,5.5c0-1,0.4-2,1.1-2.7C6.6,2,7.6,1.6,8.6,1.6
                            c1,0,2,0.4,2.8,1.1c0.7,0.7,1.1,1.7,1.1,2.7c0,1-0.4,2-1.1,2.7c-0.7,0.7-1.7,1.1-2.8,1.1c-1,0-2-0.4-2.8-1.1
                            C5.1,7.5,4.7,6.5,4.7,5.5z M15.8,20.4H1.4v-2.9c0-1.8,0.7-3.5,2-4.8c1.3-1.3,3-2,4.8-2H9c1.8,0,3.5,0.7,4.8,2c1.3,1.3,2,3,2,4.8
                            V20.4z"
            />
          </svg>
        </Link>
      </div>

      {/* COUNTRY SELECT */}
      <button
        onClick={() => setShowCountrySelect(true)}
        className="cursor-pointer"
        aria-label="Select country"
      >
        <Flag isoCode={countryFlag} size="small" />
      </button>
    </div>
  );
}
